import React, { useEffect, useState } from 'react';
import { showClientLink } from '../../utils/links';
import { fetchShowAccessToken } from '../../utils/showAccessToken';
interface ShowLinkProps {
  slug: string;
  showId: string;
}

/**
 * The one link a client needs for an entire show — every project inside it,
 * on one permanent URL. Mirrors components/portal/ClientLink.tsx exactly,
 * one level up.
 */
export function ShowLink({
  slug,
  showId
}: ShowLinkProps) {
  const [copied, setCopied] = useState(false);
  const [token, setToken] = useState('');
  const [checked, setChecked] = useState(false);
  const link = showClientLink(slug, token);
  useEffect(() => {
    let live = true;
    setToken('');
    setChecked(false);
    void fetchShowAccessToken(slug, showId).then(value => {
      if (!live) return;
      setToken(value);
      setChecked(true);
    });
    return () => {
      live = false;
    };
  }, [slug, showId]);
  async function copy() {
    if (!link) return;
    try {
      await navigator.clipboard.writeText(link);
    } catch {
      /* Clipboard unavailable — the link is on screen to copy by hand. */
    }
    setCopied(true);
    window.setTimeout(() => setCopied(false), 1800);
  }
  return <div className="mt-9 flex flex-wrap items-center gap-x-5 gap-y-4" data-id="element-1487" data-mp="3rionxrpfm1jd">
      <span className="label text-paper/40" data-id="element-1488" data-mp="3rlknfkgxgy9x">Show Link</span>

      {link ? <>
          <button type="button" onClick={copy} className="label border border-paper/40 px-5 py-3 text-paper transition-colors duration-150 ease-out hover:border-paper hover:bg-paper hover:text-ink" data-id="element-1489" data-mp="f01ug9n6ika">
            {copied ? 'Copied ✓' : 'Copy Link'}
          </button>

          {/* The same link, read-only: built from the canonical URL above so
              the two can never diverge. */}
          <a href={`${link}&preview=1`} target="_blank" rel="noreferrer" className="label border border-paper/40 px-5 py-3 text-paper transition-colors duration-150 ease-out hover:border-paper hover:bg-paper hover:text-ink" data-id="element-1490" data-mp="o313d58ekyq7">
            Preview as Client
          </a>
        </> : <span className="label-sm text-paper/30" data-id="element-1491" data-mp="2k5cr5srup5mb">
          {checked ? 'Secure link unavailable' : 'Preparing secure link…'}
        </span>}
    </div>;
}